import { logFloodgateActivity } from '../actions/publicActions';
import loadAndInitializeFloodgateEngine from '../utils/loadAndInitializeFloodgateEngine';
import { orchestrator } from 'satcheljs';

export default orchestrator(logFloodgateActivity, async actionMessage => {
    // Make sure the engine is loaded. If loaded, this is a no-op
    await loadAndInitializeFloodgateEngine(actionMessage.searchTraceId);

    // Then log the activity
    if (window.OfficeBrowserFeedback) {
        window.OfficeBrowserFeedback.floodgate
            .getEngine()
            .getActivityListener()
            .logActivity(actionMessage.activityType);
    }
});
